export default __webpack_public_path__ + "opencart.0b6ab923.png";